import { useEffect } from 'react'

import { INTERNAL_GAME_NAVIGATION, setDataToSessionStorage } from 'utils/sessionStorage'

export const useGamePageReload = () => {
  useEffect(() => {
    const handleBeforeUnload = () => {
      setDataToSessionStorage(INTERNAL_GAME_NAVIGATION, 'true')
    }

    window.addEventListener('beforeunload', handleBeforeUnload)

    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload)
    }
  }, [])
}
